// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__UzooU","empty__label":"styles_empty__label__L7lcM"};